import btcIcon  from 'assets/images/crypto-icons/btc.png'
import ethIcon  from 'assets/images/crypto-icons/eth.png'
import ltcIcon  from 'assets/images/crypto-icons/ltc.png'
import bchIcon  from 'assets/images/crypto-icons/bch.png'
import usdtIcon from 'assets/images/crypto-icons/usdt.png'
import usdcIcon from 'assets/images/crypto-icons/usdc.png'
import dashIcon from 'assets/images/crypto-icons/dash.png'
import xrpIcon  from 'assets/images/crypto-icons/xrp.png'
import trxIcon  from 'assets/images/crypto-icons/trx.png'
import polIcon  from 'assets/images/crypto-icons/pol.png'

const cryptoList = [
  { symbol: 'BTC',          name: 'Bitcoin',               logo: btcIcon,  networks: ['Bitcoin'] },
  { symbol: 'ETH',          name: 'Ethereum',              logo: ethIcon,  networks: ['ERC20'] },
  { symbol: 'LTC',          name: 'Litecoin',              logo: ltcIcon,  networks: ['Litecoin'] },
  { symbol: 'BCH',          name: 'Bitcoin Cash',          logo: bchIcon,  networks: ['Bitcoin Cash'] },
  { symbol: 'USDT_ERC20',   name: 'Tether (ERC20)',        logo: usdtIcon, networks: ['ERC20'] },
  { symbol: 'USDT_TRC20',   name: 'Tether (TRC20)',        logo: usdtIcon, networks: ['TRC20'] },
  { symbol: 'USDT_POLYGON', name: 'Tether (Polygon)',      logo: usdtIcon, networks: ['Polygon'] },
  { symbol: 'USDC_ERC20',   name: 'USD Coin (ERC20)',      logo: usdcIcon, networks: ['ERC20'] },
  { symbol: 'USDC_POLYGON', name: 'USD Coin (Polygon)',    logo: usdcIcon, networks: ['Polygon'] },
  { symbol: 'DASH',         name: 'Dash',                  logo: dashIcon, networks: ['Dash'] },
  { symbol: 'XRP',          name: 'Ripple',                logo: xrpIcon,  networks: ['Ripple'] },
  { symbol: 'TRX',          name: 'Tron',                  logo: trxIcon,  networks: ['TRON'] },
  { symbol: 'POL',          name: 'Polygon',               logo: polIcon,  networks: ['Polygon'] },
]

export default cryptoList
